.full-center-content {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  // background-color: white;
  z-index: 999999;

  &_fix-position {
    position: absolute;
    max-width: 99vw;
  }

  &_allow-overflow {
    overflow: visible;
  }
}
